import React from 'react';
import { View } from 'react-native';
import { UserGroup } from '../../../../../../../../constants/Types';
import Option from './Option';

interface AddGroupListProps {
  groups: UserGroup[],
  tags: string[],
  update,
}

const AddGroupList = ({
  groups, tags, update,
}: AddGroupListProps) => <View testID='select-issue-user-groups-list'>
    {groups.filter((group: UserGroup) => !tags?.includes(group.UserGroupId))
      ?.map((group: UserGroup, index: number) => <Option
        key={`new_user_group_option_${group.UserGroupId}`}
        text={group.Name}
        selected={tags?.length && group.UserGroupId === tags[tags?.length]}
        onPress={() => update(group.UserGroupId)}
        testID={`template-issue-user-group-option#${index + 1}`}
      />)}
  </View>;

export default AddGroupList;
